import { getPropsFromNode, nodeIs, nodeMatches } from '../utils'
import { ArticleAside } from '../../components/molecule/ArticleContent/entry'
import { h } from '../parser/utils'

import { extractSide } from './_utils'

export const NAME = 'aside'

export const COMPONENTS = {
  ArticleAside,
}

export function matches(node) {
  return nodeIs(node, 'aside') ||
    nodeMatches(node, '.infobox, .right.border, .left.border')
}

export async function transform(node, next, ctx) {
  const children = await next(node.childNodes, ctx)

  const props = getPropsFromNode(node, ['class'])
  const side = extractSide(node)

  return h(
    ArticleAside,
    {
      ...props,
      ...(side ? { float: side, 'break': side } : null),
      boxed: { padded: true },
    },
    ...children,
  )
}
